<template>
  <div class="question-container">
    <!-- PREVIEW MODE -->
    <div v-if="mode == 0">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="isSkippable(question)">Optional</span>
        </div>
        <div class="col-md-7">
          <template v-if="answer && answer.answerText">
            <div v-html="answer[JsonFieldToDisplay()]"></div>
          </template>
        </div>
        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4" v-html="answer.score"></div>
          </div>
        </template>
        <template v-else-if="isSkippable(question)">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4" v-html="question.skipScore || 0"></div>
          </div>
        </template>
      </div>
    </div>

    <!-- EDIT MODE -->
    <div v-if="mode == 1">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="isSkippable(question)">Optional</span>
          <span class="skipped-question-box ml-15 d-inline-box pt-2" v-if="isQuestionSkipped()">Skipped </span>
        </div>
        <div class="col-md-7" :class="isQuestionSkipped() ? 'disable-question' : ''">
          <b-form-textarea id="textarea" v-model="updatedAns" placeholder="Modify Answer" rows="5" :disabled="answer && answer.isDisabled" :name="question.id" :state="!hasFieldError" data-vv-as="Text" :value="answer && answer.answerText" :lang="selectedLanguageCulture"> </b-form-textarea>
          <span class="text-danger" v-if="hasFieldError">
            <p v-html="fieldErrorText"></p>
          </span>
          <span v-else-if="hasFieldWarning" class="text-warning pl-5 fw-bold pt-10" v-html="fieldWarningText"> </span>
        </div>
        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4" v-html="answer.score"></div>
          </div>
        </template>
        <template v-else-if="isSkippable(question)">
          <div class="ml-25 d-inline-block pt-20" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4" v-html="question.skipScore || 0"></div>
          </div>
        </template>
      </div>
    </div>

    <!-- RESPONSE MODE -->
    <div v-else-if="mode == 2">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <div class="row">
            <div class="col-md-12 d-flex p-0 answers">
              <span class="changed" v-if="answer && answer.edit_status == 1"></span>
              <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
              <template v-if="activityType == 'activity'">
                <span class="question-text" v-html="question.formattedBody"></span>
              </template>
              <template v-else>
                <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
                <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
              </template>
              <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="isSkippable(question)">Optional</span>
            </div>
            <!-- CURRENT ANSWER -->
            <template v-if="answer && answer.answer_text">
              <div class="col-md-12 d-flex pl-30">
                <span class="text-align" v-html="selectedLanguageCulture == 'EN' ? answer.answer_text : answer.display_answer_text"></span>
              </div>
              <div class="row">
                <div class="d-inline-block ml-25 pt-10" v-if="showScore && activityType == 'activity' && answer.score != null">
                  <label>Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4" v-html="answer.score"></div>
                </div>
              </div>
            </template>
            <template v-else-if="isSkippable(question)">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4" v-html="question.skipScore || 0"></div>
              </div>
            </template>
          </div>
        </div>
        <div class="col-md-7 previous-answer" v-if="answer && answer.edit_status == 1">
          <div>
            <span class="previous-value-mark"></span>
            <div class="previous-value ml-3">PREVIOUS RESPONSE</div>
            <template v-if="answer && answer.privius_answer_text">
              <div>
                <span class="text-align" v-html="selectedLanguageCulture == 'EN' ? answer.privius_answer_text : answer.privius_display_answer_text"></span>
              </div>
              <div class="row">
                <div class="d-inline-block ml-0 pt-10" v-if="showScore && answer.privius_score != null">
                  <label>Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4" v-html="answer.privius_score"></div>
                </div>
              </div>
            </template>
            <template v-else-if="isSkippable(question)">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4" v-html="question.skipScore || 0"></div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import activityCommonMixin from "./activity-common-mixin";
export default {
  name: "TextResponse",
  mixins: [activityCommonMixin],
  data() {
    return {
      updatedAns: this.answer && this.answer.answerText,
      hasFieldError: null,
      fieldErrorText: "",
      hasFieldWarning: false,
      fieldWarningText: ""
    };
  },
  watch: {
    mode: {
      handler(value) {
        if (value == 0) {
          this.updatedAns = this.answer.answerText;
        }
      }
    },
    updatedAns() {
      if (this.answer) {
        this.answer.answerText = this.updatedAns;
        this.answer.score = this.question.score;
        this.answer.computedScore = this.answer.score;
        this.answerUpdated();
      }
    },

    hasFieldError(val) {
      this.question.hasFieldError = val;
    },
    fieldErrorText(val) {
      this.question.fieldErrorText = val;
    }
  },
  props: {
    mode: Number,
    answer: Object,
    question: Object,
    selectedLanguageCulture: String,
    stepIndex: Number,
    surveyData: Object,
    usage: Object,
    activityType: String
  },
  methods: {
    isSkippable(question) {
      return question.isSkippable || question.isSkipped;
    },
    answerUpdated() {
      this.checkForFieldErrors();
      this.$emit(`answerChanged`, {
        questionId: this.question.id,
        newAns: this.updatedAns
      });
    },
    getTextMaxLength() {
      if (this.question.subType === "Unlimited") {
        return +Infinity;
      }
      return this.question.textLimit;
    },
    checkForFieldErrors() {
      const { textLimit, dataEditChecks } = this.question;

      this.resetAllErrors();
      this.question.dataChecks = [];
      if (dataEditChecks) {
        let softDataCheck = false;
        const alphanumericRegx = /^[a-zA-Z0-9 ]*$/;
        const numericRegx = /[^a-zA-Z ]+/;
        const alphabetRegx = new RegExp("^[a-zA-Z]+$");
        for (let k = 0; k < dataEditChecks.length; k++) {
          if (dataEditChecks[k].check == "SOFT") {
            if (dataEditChecks[k].type == "NOT_BLANK" && this.updatedAns == "") {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              this.fieldWarningText = `Your response is requested. Please enter a response.`;
              this.question.isSkippable = true;
              this.question.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: dataEditChecks[k].type,
                message: this.fieldWarningText
              });

              softDataCheck = true;
            }
            if (dataEditChecks[k].type == "DATA_TYPE" && dataEditChecks[k].value == "Alphabet" && !alphabetRegx.test(this.updatedAns)) {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              this.fieldWarningText = `Your response is not in the expected format: Alphabet. Please review your response.`;
              this.question.isSkippable = true;
              this.question.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: dataEditChecks[k].type,
                message: this.fieldWarningText
              });
              softDataCheck = true;
            }
            if (dataEditChecks[k].type == "DATA_TYPE" && dataEditChecks[k].value == "Alphanumeric" && !alphanumericRegx.test(this.updatedAns)) {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              this.fieldWarningText = `Your response is not in the expected format: Alphanumeric. Please review your response.`;
              this.question.isSkippable = true;
              this.question.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: dataEditChecks[k].type,
                message: this.fieldWarningText
              });
              softDataCheck = true;
            }
            if (dataEditChecks[k].type == "DATA_TYPE" && dataEditChecks[k].value == "Numeric" && !numericRegx.test(this.updatedAns)) {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              this.fieldWarningText = `Your response is not in the expected format: Numeric. Please review your response.`;
              this.question.isSkippable = true;
              this.question.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: dataEditChecks[k].type,
                message: this.fieldWarningText
              });
              softDataCheck = true;
            }
          } else {
            if (dataEditChecks[k].type == "NOT_BLANK" && this.updatedAns == "") {
              this.hasFieldError = true;
              this.fieldErrorText = "Please enter a response.";
              this.question.isSkippable = false;
              return false;
            } else if (dataEditChecks[k].type == "DATA_TYPE" && dataEditChecks[k].value == "Alphabet" && !alphabetRegx.test(this.updatedAns)) {
              this.hasFieldError = true;
              this.fieldErrorText = "Please enter a response with format: Alphabet.";
              this.question.isSkippable = false;
              return false;
            } else if (dataEditChecks[k].type == "DATA_TYPE" && dataEditChecks[k].value == "Alphanumeric" && !alphanumericRegx.test(this.updatedAns)) {
              this.hasFieldError = true;
              this.fieldErrorText = "Please enter a response with format: Alphanumeric.";
              this.question.isSkippable = false;
              return false;
            } else if (dataEditChecks[k].type == "DATA_TYPE" && dataEditChecks[k].value == "Numeric" && !numericRegx.test(this.updatedAns)) {
              this.hasFieldError = true;
              this.fieldErrorText = "Please enter a response with format: Numeric.";
              this.question.isSkippable = false;
              return false;
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }
      this.validateMinMaxErrors(this.updatedAns, textLimit);
    },
    validateMinMaxErrors(answer, textLimit) {
      if (answer.length > textLimit && textLimit > 1) {
        this.hasFieldError = true;
        this.fieldErrorText = `Please enter number of characters between 1 and ${textLimit}.`;

        return true;
      }

      return false;
    },
    resetAllErrors() {
      this.hasFieldError = false;
      this.fieldErrorText = "";
      this.hasFieldWarning = false;
      this.fieldWarningText = false;
    },
    isQuestionSkipped() {
      return this.answer.isSkipped;
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.changed {
  position: absolute;
  left: -29px;
  top: 0;
  width: 18px;
  height: 51px;
  border-radius: 1px;
  background-color: #f5a623;
}

.question-text {
  display: inline;
}

.previous-value-mark {
  width: 9px;
  height: 51px;
  background-color: #f5a623;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.previous-value {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #f5a623;
  margin-bottom: 9px;
  margin-top: 3px;
}

.answers {
  font-weight: 600;
  color: #000000;
}
</style>
